
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.5 0C4.701 0 0 4.701 0 10.5S4.701 21 10.5 21 21 16.299 21 10.5C20.994 4.704 16.296.006 10.5 0zm0 20.344a9.814 9.814 0 01-7.09-3.026 7.253 7.253 0 017.09-5.732 3.62 3.62 0 110-7.242 3.62 3.62 0 010 7.242c3.42 0 6.374 2.39 7.09 5.732a9.814 9.814 0 01-7.09 3.026z","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/management/accounts.svg